import { render, staticRenderFns } from "./Residents.vue?vue&type=template&id=5671ef72&scoped=true&"
import script from "./Residents.vue?vue&type=script&lang=ts&"
export * from "./Residents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671ef72",
  null
  
)

export default component.exports